import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/BuildingDetail/selectRow',
                {
                    params,
                });

            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async copy(params)
    {
        try
        {
            const response = await axios.post('/BuildingDetail/copy', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async save(params)
    {
        try
        {
            let response;
            if (typeof params.id !== 'undefined' && params.id != '')
            {
                response = await axios.post('/BuildingDetail/updateRow', params);
            }
            else
            {
                response = await axios.post('/BuildingDetail/insertRow', params);
            }
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/BuildingDetail/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async itemChecked(params)
    {
        try
        {
            const response = await axios.post('/BuildingDetail/itemChecked', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async generateCsv(params)
    {
        try
        {
            const response = await axios.post('/BuildingDetail/generateCsv', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async downloadCsv(params)
    {
        try
        {
            const param = { ...params };
            for (const key in param)
            {
                if (param[key] == null)
                {
                    delete (param[key]);
                }
            }
            // const url = axios.returnOperationUrl(`/BuildingDetail/downloadCsv?${new URLSearchParams(param).toString()}`, param);
            window.open(`/BuildingDetail/downloadCsv?${new URLSearchParams(param).toString()}`);
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
    async importCSV(params)
    {
        try
        {
            const response = await axios.post('/BuildingDetail/importCSV', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: 'AXIOS_ERROR', params: { error: e } });
        }
    },
};
